module.exports = __webpack_public_path__ + "img/ferienhaus_debontje_greetsiel_treppe_1.24aba1df.jpg";